import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Registro from "../pages/registro/page";
import Gracias from "../pages/gracias/page";
import ConfirmacionCompra from "../pages/confirmacionCompra/page";
import PruebaEnIngles from "../pages/pruebaeningles/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Registro />,
  },
  {
    path: "/gracias",
    element: <Gracias />,
  },
  {
    path: "/confirmacionCompra",
    element: <ConfirmacionCompra />,
  },
  {
    path: "/pruebaeningles",
    element: <PruebaEnIngles />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
